//src/components/OrdersPage/OrdersDetailPage.jsx

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { authFetch } from "../api/api";
import Card from "../UI/Card";
import Button from "../UI/Button";
import { useNavigate } from "react-router-dom";
import AddProductModal from "./ProductOrderPage/AddProductModal";
import ExtraExpensesModal from "./modals/ExtraExpensesModal";
import { getOrderFinanceByOrderId } from "../api/orderFinanceApi";
import { useTranslation } from "react-i18next";
import UploadPhotoModal from "./modals/UploadPhotoModal";
import OrderFormModal from "./OrderFormModal";
import UploadDocumentModal from "./OrderDocumentsPage/UploadDocumentModal";
import OrderCalendarHistory from "./OrderHistory/OrderCalendarHistory";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const API_URL = `${BASE_URL}/api/orders/`;



export default function OrdersDetailPage() {
  const { id } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showExpensesModal, setShowExpensesModal] = useState(false);
  const [finance, setFinance] = useState(null);
  const { t } = useTranslation("OrdersPage");
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [modalOrder, setModalOrder] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  

  useEffect(() => {
    const loadOrder = async () => {
      try {
        const res = await authFetch(`${API_URL}${id}/`);
        if (!res.ok) throw new Error("Ошибка загрузки заказа");

        const data = await res.json();
        setOrder(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadOrder();
  }, [id]);



  useEffect(() => {
  const loadFinance = async () => {
    try {
      const data = await getOrderFinanceByOrderId(id);
      setFinance(data);
    } catch (err) {
      console.error("Ошибка финансов:", err);
    }
  };

  loadFinance();
}, [id]);



  if (loading) {
    return <div className="w-full max-w-5xl mx-auto mt-10">{t("loading")}</div>;
  }

  if (!order) {
    return <div className="w-full max-w-5xl mx-auto mt-10">{t("not_found")}</div>;
  }

  const items = order.items || [];

  const clientTotal = items.reduce(
    (s, i) => s + Number(i.client_price || 0),
    0
  );

  const internalTotal = items.reduce(
    (s, i) => s + Number(i.purchase_price || 0),
    0
  );

  const openModal = (order = null) => {
    setModalOrder(order);
    setShowEditModal(true);
  };

  const closeModal = () => {
    setModalOrder(null);
    setShowEditModal(false);
  };
  

  return (
    <div className="w-full max-w-5xl mx-auto mt-10 space-y-6">

      {/* HEADER */}
      <div>
        <h1 className="text-3xl font-bold">
          {t("order")} #{order.order_code}
        </h1>
        <p className="text-gray-500 mt-1">
          {t("order_detail")}
        </p>
        <Button
          onClick={(e) => {
          e.stopPropagation();
          openModal(order);
          }}
        >
          Edit
        </Button>
      </div>

      {/* BASIC INFO */}
      <Card>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            {t("client_and_order")} 
            <p><b>{t("client")}:</b> {order.client_data || "-"}</p>
            <p><b>{t("date")}:</b>  {order.start_date || "-"}</p>
            <p><b>{t("order_status")}:</b> {order.status || "-"} </p>
            <p><b>Тип поставки:</b> {order.ordertype || "-"} </p>
            <p><b>{t("commission_rate")}:</b> {order.commission_rate || "-"}%</p>
            <p><b>Per cent for production:</b> {order.production_deposit_percent} %</p>
            <p><b>Client production deposit amount:</b> ¥{order.client_production_deposit_amount}</p>
            <p><b>Our production deposit amount:</b> ¥{order.our_production_deposit_amount}</p>
            <p className="font-bold text-green-600">
              {t("total_profit")}: ¥{order.profit}
            </p>
          </div>

          <div>
            {t("logistics")}
            <p><b>{t("destination_city")}:</b> {order.destination_city_data?.name || "-"}</p>
            <p><b>{t("expeditor")}:</b> {order.expeditor_data?.name || "-"}</p>
            <p><b>{t("tracking")}:</b> {order.expeditor_tracking || "-"}</p>
          </div>

          <div>
            {t("recipient")}
            <p><b>{t("recipient_name")}:</b> {order.recipient_name || "-"}</p>
            <p><b>{t("phone")}:</b> {order.recipient_phone || "-"}</p>
            <p><b>{t("recipient_address")}:</b> {order.recipient_address || "-"}</p>
            <p><b>{t("recipient_zip")}:</b> {order.recipient_zip|| "-"}</p>
          </div>
          
          <div>
            {t("finance")}
            <p><b>{t("delivery_for_client")}:</b> ¥{order.price_delivery || 0}</p>
            <p><b>{t("delivery_for_us")}:</b> ¥{order.price_to_expeditor || 0}</p>
            <p><b>{t("goods_price_client")}:</b> ¥{order.client_all_goods_price || 0}</p>
            <p><b>{t("goods_price_us")}:</b> ¥{order.all_goods_price_for_us || 0}</p>
            <p><b>{t("extra_expenses_client")}:</b> ¥{order.all_expences_for_client || 0}</p>
            <p><b>{t("extra_expenses_us")}:</b> ¥{order.all_expences_for_us || 0}</p>
            <p><b>{t("expenses_profit")}:</b> ¥{order.expences_profit || 0}</p>
            <p><b>{t("delivery_profit")}:</b> ¥{order.delivery_profit}</p>
            <p><b>{t("profit_russia")}</b> ¥{order.total_profit_in_russia || 0}</p>
            <p><b>{t("profit_china")}</b> ¥{order.total_profit_in_china || 0}</p>
            <p><b>Client need to pay for production starting</b>¥{order.client_production_deposit_amount || "error"}</p>
            <p><b>We need to pay for production starting</b>¥{order.our_production_deposit_amount || "error"}</p>
          </div>
          <div>
            Данные по официальной поставке
            <p><b>INCOTERMS Россия:</b> {order.incoterms_russia || "-"}</p>
          </div>

          <div>
            Комментарий:
            <p>{order.comment || "-"}</p>
          </div>
          

        </div>
      </Card>

      {/* ===================== */}
      {/* STUB BLOCKS (оставляем) */}
      {/* ===================== */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

      <Card
        onClick={() => navigate(`/orders/${id}/products`)}
      >
        <div className="flex justify-between">
          <h2 className="font-semibold text-lg mb-3">{t("products")}</h2>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(true);
              }}
            >
              {t("add")}

            </Button>
        </div>

        {items.length === 0 ? (
          <p className="text-gray-500">{t("no_products")}</p>
        ) : (
          <div className="space-y-3">
            {items.map((item) => {
              const p = item.product_data || {};

              return (
                <div 
                  key={item.id} 
                  className="border rounded p-3 space-y-1"
                >
                  <p className="font-semibold">
                    {p.name_en || "-"} / {p.name_cn || "-"}
                  </p>

                  <p className="text-sm text-gray-700">
                    {t("quantity")}: {item.quantity}
                  </p>

                  <p className="text-sm text-gray-700">
                    {t("product_price_client")}: ¥{item.client_price}
                  </p>

                  <p className="text-sm text-gray-700">
                    {t("product_price_for_us")}: ¥{item.purchase_price}
                  </p>

                  <p className="text-sm font-medium text-green-600">
                    {t("profit")}: ¥{item.profit}
                  </p>
                </div>
              );
            })}
          </div>
        )}
      </Card>

        <Card
          onClick={() => navigate(`/orders/${id}/finances`)}
          className="cursor-pointer hover:shadow-md transition"
        >
          <div className="flex justify-between">
            <h2 className="font-semibold text-lg mb-2">{t("finance")}</h2>
            <Button
              onClick={(e) => {
                e.stopPropagation();
              }}
            variant="primary"
            >
              {t("add")}
            </Button>
          </div>

          {!finance ? (
            <p className="text-gray-500">{t("finance_data_empty")}</p>
          ) : (
            <div className="space-y-2 text-sm">

             

              <hr className="my-2" />

            </div>
          )}
        </Card>

        <Card
          onClick={() => navigate(`/orders/${id}/photos`)}
        >
          <div className="flex justify-between">
            <h2 className="font-semibold text-lg mb-2">
              {t("photos") || "Фотоматериалы"}
            </h2>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                // тут позже откроем upload modal
                setShowPhotoModal(true);
              }}
            >
              {t("add")}
            </Button>
          </div>
          {!order.photos || order.photos.length === 0 ? (
            <p className="text-gray-500">
              {t("no_photos") || "Нет фото"}
            </p>
          ) : (
            <div className="grid grid-cols-2 gap-2 mt-2">
              {order.photos.map((photo) => (
                <div
                  key={photo.id}
                  className="border rounded p-2 text-sm"
                >
                  <img
                    src={photo.image}
                    alt="order photo"
                    className="w-full h-32 object-cover rounded"
                  />
                  {photo.comment && (
                    <div className="text-gray-500 text-xs mt-1">
                      {photo.comment}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Card>


        <Card
          onClick={() => navigate(`/orders/${id}/expenses`)}
        >
          <div className="flex justify-between">
            <h2 className="font-semibold text-lg mb-2"> {t("extra_expenses")}</h2>
            <Button onClick={(e) => {


//                e.stopPropagation();
            //    setShowModal(true);
                e.stopPropagation();
                setShowExpensesModal(true);
                }}
              >
              {t("add")}
            </Button>
          </div>
            {order.extra_expenses?.length === 0 ? (
              <p className="text-gray-500">{t("no_expenses")}</p>
            ) : (
              <div className="space-y-2 mt-2">
                {order.extra_expenses.map((exp) => (
                  <div
                    key={exp.id}
                    className="border rounded p-2 text-sm"
                  >
                    <div className="font-semibold">
                      {exp.title}
                    </div>

                    <div className="text-gray-700">
                      {t("client")}: ¥{exp.price_client}
                    </div>

                    <div className="text-gray-700">
                      {t("price_for_us")}: ¥{exp.price_internal}
                    </div>

                    {exp.comment && (
                      <div className="text-gray-500 text-xs mt-1">
                        {exp.comment}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
        </Card>

        {/*история*/}
        <Card>
          <div className="flex justify-between">
            <h2 className="font-semibold text-lg mb-2">
              {t("history")}
            </h2>
            <Button>
              {t("add")}
            </Button>
          </div>
          <OrderCalendarHistory
            orderId={id}
          />
        </Card>


        {/*Раздел с документами*/}
        <Card
          onClick={() => navigate(`/orders/${id}/documents`)}
        >
          <div className="flex justify-between">
            <h2 className="font-semibold text-lg mb-2">
              {t("documents") || "Документы"}
            </h2>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setShowDocumentModal(true);
              }}
            >
              {t("add")}
            </Button>
          </div>
          <p className="text-gray-500">
            {t("documents_placeholder") || "Нет документов"}
          </p>
        </Card>


      </div>


      {showEditModal && (
        <OrderFormModal
          order={modalOrder}
          onClose={closeModal}
          onSave={() => window.location.reload()}
        />
      )}

      {/* ===================== */}
      {/* 🔥 ПЕРЕНЕСЁННЫЙ КОД */}
      {/* ===================== */}

      {/* PRODUCTS */}
      
      {showModal && (
            <AddProductModal
              orderId={id}
              clientId={order.client}
              onClose={() => setShowModal(false)}
              onSuccess={() => window.location.reload()}
            />
          )}

      {showExpensesModal && (
        <ExtraExpensesModal
          orderId={id}
          onClose={() => setShowExpensesModal(false)}
          onSuccess={() => window.location.reload()}
        />
        
      )}
        {/*модалка для загрузки фото для заказа*/}
        {showPhotoModal && (
          <UploadPhotoModal
            orderId={id}
            onClose={() => setShowPhotoModal(false)}
            onSuccess={() => window.location.reload()}
          />
        )}

{/*модалка для загрузки документов*/}

      {showDocumentModal && (
        <UploadDocumentModal
          orderId={id}
          onClose={() => setShowDocumentModal(false)}
          onSuccess={() => window.location.reload()}
        />
      )}

    </div>
  );
}